import PropTypes from 'prop-types';
import { AuthProvider as Provider } from 'react-oauth2-code-pkce';
import LC from '@constants/login';
import { SK } from '@constants';
import {
  isPublicRoute, isValidRoutePath,
  StorageUtility,
} from '@utils';

const urlParams = new URLSearchParams(window.location.search);
const ci = urlParams.get('ci');

const clientId = StorageUtility.getItem(SK.CI) || ci;

const authConfig = {
  clientId,
  authorizationEndpoint: LC.LOGIN,
  tokenEndpoint: LC.TOKEN,
  redirectUri: LC.REDIRECT_URI,
  onRefreshTokenExpire: (event) => {
    console.log({ event }, 'onRefreshTokenExpire');
    // event.login();
    // return window.confirm('Tokens have expired. Refresh page to continue using the site?') && event.login();
  },
  decodeToken: false,
  scope: LC.SCOPES,
  clearURL: true,
  autoLogin: !isPublicRoute() && isValidRoutePath(),
  storage: 'session',
  preLogin: () => {
    console.log('preLogin called');
  },
  extraAuthParameters: {
    // username_hint: loginEmail,
    // modes: ['PUB'],
  },
};

const AuthProvider = ({ children }) => (
  <Provider authConfig={authConfig}>
    {children}
  </Provider>
);

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthProvider;
